export const useSxStyles = () => {
  return {
    templateOption: {
      '& .MuiListItemText-secondary': {
        whiteSpace: 'pre-wrap',
      },
    },
  };
};
